import './style.scss';
import { initialize_select2 } from '../../scripts/initialize-select2';
import { initialize_cf7_success_view } from '../../scripts/initialize-cf7-success';

export function contact_us_page(root = document) {
  root.querySelectorAll('[data-component="contact-us-page"]').forEach((block) => {
    if (block.dataset.contactUsInitialized === 'true') return;

    initialize_select2(block);
    initialize_cf7_success_view(block, {
      defaultSelector: '[data-contact-default]',
      successSelector: '[data-contact-thank-you]',
      headingSelector: '[data-contact-thank-you-heading]',
      stateDataKey: 'contactState',
    });

    block.dataset.contactUsInitialized = 'true';
  });
}
